import DatabaseList from "./pages/ListPage.vue";
import DatabaseDetail from "./pages/FormPage.vue";
import DatabaseIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/database",
    component: DatabaseIndex,
    redirect: "/database/list",
    name: "database",
    children: [
      {
        path: "list",
        component: DatabaseList,
        name: "database.list",
      },
      {
        path: "create",
        component: DatabaseDetail,
        name: "database.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: DatabaseDetail,
        name: "database.edit",
        props: { create: false },
      },
    ],
  },
];
